//
//
//
//
//
//
//
//
//
//
//
//
//

import LifestyleAboveTheFold from '~/components/lifestyle/Lifestyle_AboveTheFold.vue';
import LifestyleBanner from '~/components/lifestyle/Lifestyle_Banner.vue';
import LifestyleRounds from '~/components/lifestyle/Lifestyle_Rounds.vue';
import LifestyleFight from '~/components/lifestyle/Lifestyle_Fight.vue';
import LifestylePlan from '~/components/lifestyle/Lifestyle_Plan.vue';
import LifestyleLocation from '~/components/lifestyle/Lifestyle_Location.vue';
import LifestyleFamily from '~/components/lifestyle/Lifestyle_Family.vue';
import LifestyleCTA from '~/components/lifestyle/Lifestyle_CTA.vue';
import { metaData } from '~/configuration/metaData';

export default {
  name: 'Lifestyle',
  head: {
    ...metaData.lifestyle,
  },
  components: {
    LifestyleAboveTheFold,
    LifestyleBanner,
    LifestyleRounds,
    LifestyleFight,
    LifestylePlan,
    LifestyleLocation,
    LifestyleFamily,
    LifestyleCTA,
  },
};
